import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

export const QuoteIcon = styled.img`
  width: 24px;
  height: 24px;
  align-self: flex-start;
`;

export const Title = styled.span`
  font-size: 16px;
  line-height: 1.2;
  font-weight: 700;
  color: #000000;
`;

export const Text = styled.blockquote`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;
